import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { DeleteBranchesContainerProps } from "../../../../interfaces/containers";
import Delete from "../../../../pages/Profile/Branches/Delete";
import { 
    getBranches,
    deleteBranch, 
    cleanDeleteBranch 
} from "../../../../actions/profile";

function mapStateToProps(state: DeleteBranchesContainerProps) {
    return {
        user: state.auth.user,
        branches: state.profile.branches,
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getBranches,
        deleteBranch, 
        cleanDeleteBranch,
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Delete);